import React, { useState, useContext } from 'react';
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
} from 'react-device-detect';
import themeContext from '../../context/theme/ThemeContext';
import {
  PrimaryButton,
  TextField,
} from '@fluentui/react';
import ClearIcon from '../SVGComponents/ClearIcon';
import { t } from 'i18next';
import { TABS } from '../../constants/Constants';
import '../../components/ListView/ListViewStyles.css';
import '../../pages/StudyList/StudyList.css';

const SortPopupFilterSectionV4 = (props) => {
  const [filterValue, setFilterValue] = useState('');
  const [applyButtonEnabled, setApplyButtonEnabled] = useState(false);
  const { themeName, getThemeColor } = useContext(themeContext);

  const handleApplyClick = props.handleApplyClick;
  const showSearch =
    props.showSearch != undefined && props.showSearch != null
      ? props.showSearch
      : true;

  const searchInputStyle = {
    root: {
      width: isMobile ? '100%' : '160px',
    },
    field: {
      borderRadius: '7px',
    },
  };

  const handleEnterKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleApplyClick(filterValue.trim());
    }
  };

  const handleRemoveFilters = () => {
    setFilterValue('');
    handleApplyClick('');
  };

  const handleApplyFilterClick = (filterValue) => {
    handleApplyClick(filterValue);
  };

  return (
    <div
      className="top-section-list-view-v3"
      style={{
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'space-between',
        background: themeName === "light" ? TABS.LIGHT_GLOBAL_GRAY : "unset",
        borderLeft: "none",
        borderRight: "none",
        borderBottom: "none",
        padding: "10px 0px",
        marginTop: "0px",
        width: "100%",
      }}
    >
      <div className="section-filter" style={{ display: 'flex', alignItems: 'center' }}>
        {showSearch && (
          <>
            <p className="sort-search-text">Search By</p>

            <span className="patient-search-input-box">
              <TextField
                label=""
                placeholder={props.placeholder || "Search styles..."}
                styles={searchInputStyle}
                name="searchStyles"
                value={filterValue}
                onChange={(e, data) => {
                  if (data === '') {
                    setApplyButtonEnabled(false);
                  } else {
                    setApplyButtonEnabled(true);
                  }
                  setFilterValue(data);
                }}
                onKeyDown={handleEnterKeyPress}
              />
              <span
                className="cancel-patient-search"
                onClick={(event) => {
                  event.stopPropagation();
                  handleRemoveFilters();
                }}
              >
                {filterValue.length > 0 && <ClearIcon />}
              </span>
            </span>

            <PrimaryButton
              type="button"
              iconProps={{
                iconName: 'Search',
                cursor: 'pointer',
              }}
              onClick={() => {
                if (filterValue.trim() !== '') {
                  handleApplyFilterClick(filterValue.trim());
                }
              }}
              text={''}
              className={
                !(filterValue.trim() !== '' && applyButtonEnabled)
                  ? 'common-default-inactive-button study-list-filter-button search-active-button'
                  : 'common-default-active-button study-list-filter-button search-active-button'
              }
              styles={{
                root: {
                  width: '10px',
                  cursor: !(filterValue.trim() !== '') ? 'not-allowed' : 'pointer',
                },
              }}
            />
          </>
        )}
      </div>
      <div style={{ display: 'flex' }}>
        {props.buttonsTopBar && props.buttonsTopBar.map((ele, index) => {
          return <React.Fragment key={index}>{ele.button}</React.Fragment>;
        })}
      </div>
    </div>
  );
};

export default SortPopupFilterSectionV4;